import { Checkbox } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import { Eye, X } from "lucide-react";
import i18n from "@lib/i18n";
import ActionButton from "@components/ActionButton";
import { cn } from "@lib/utils/tailwind";
import { User } from "@lib/types/users";

export const columns = (
  viewUser: (user: User) => void,
  handeDeleteUser: (user: User) => void
): ColumnDef<User>[] => [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={() => table.toggleAllRowsSelected()}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onChange={() => row.toggleSelected()}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "first_name",
    header: i18n.t("table.firstName"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.first_name}
      </span>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "last_name",
    header: i18n.t("table.lastName"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.last_name}
      </span>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "email",
    header: i18n.t("table.email"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.email}
      </span>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "organization",
    header: i18n.t("table.organization"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {row.original.organization}
      </span>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "status",
    header: i18n.t("table.status"),
    cell: ({ row }) => (
      <span className="text-neutral-600 leading-none font-book text-base">
        {i18n.t(`admin.userStatus.${row.original.status}`)}
      </span>
    ),
    enableSorting: true,
  },
  {
    id: "actions",
    header: i18n.t("table.actions"),
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex w-full items-center justify-center gap-1">
          <ActionButton
            title={i18n.t("general.view")}
            onClick={() => viewUser(row.original)}
          >
            <Eye size="20" />
          </ActionButton>
          <ActionButton
            title={i18n.t("general.delete")}
            onClick={() => {
              handeDeleteUser(row.original);
            }}
            className={cn(row.original.id ? "block" : "opacity-0")}
            disabled={!row.original.id}
          >
            <X size="20" color="red" />
          </ActionButton>
          {/*   <ActionButton
              title={i18n.t("general.edit")}
              onClick={() => {
                setDriverToEdit(row.original);
                setDialogOpen(true);
              }}
              disabled={!row.original.id}
            >
              {row.original.id ? <Pencil size="20" /> : <PenOff size="20" />}
            </ActionButton>

            <ActionButton
              title={i18n.t("general.delete")}
              onClick={() => {
                deleteDriver(row.original);
              }}
              className={cn(row.original.id ? "block" : "opacity-0")}
              disabled={!row.original.id}
            >
              <X size="20" color="red" />
            </ActionButton> */}
        </div>
      );
    },
  },
];
